import type { FileTypeFilterOption } from '@aline/common';
import { CustomOperatorValue } from '@aline/common';
import type { GridFilterItem } from '@mui/x-data-grid-premium';

export interface FileTypeFilterItem extends GridFilterItem {
  operator: CustomOperatorValue.FileType | CustomOperatorValue.FileTypeNotAnyOf;
  value?: FileTypeFilterOption[];
}

export function getIsFileTypeFilterItem(item: GridFilterItem): item is FileTypeFilterItem {
  return (
    item.operator === CustomOperatorValue.FileType ||
    item.operator === CustomOperatorValue.FileTypeNotAnyOf
  );
}
